import {
  AUTENTICADO,
  INICIAR_SESION,
  CERRAR_SESION,
  AUTENTICADO_ERROR,
} from "../types";

// eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case INICIAR_SESION:
    case AUTENTICADO:
      return {
        ...state,
        usuario: action.payload,
      };
    case AUTENTICADO_ERROR:
    case CERRAR_SESION:
      return {
        ...state,
        usuario: null,
      };
    default:
      return state;
  }
};
